export default __webpack_public_path__ + "static/media/tutoring2.a22c800d.svg";